export enum CustomQuotationTypeEnum {
  PALETTE = "PALETTE",
  PARCEL = "PARCEL",
  OTHER = "OTHER",
}
